// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Tabs, Radio, Row, Col } from "antd";
import ZenVerBarChart from "./Common/Graph/ZenVerBarChart";
import ZenHorBarChart from "./Common/Graph/ZenHorBarChart";
import ZenWaterfallChart from "./Common/Graph/ZenWaterfallChart";
import ZenClusterColumnVer from "./Common/Graph/ZenClusterColumnVer";

import ZenGauge from "./Common/Graph/ZenGauge";

import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import digitalFactoryLogo from "../../images/DigitalFactory.png";
import { Link } from "react-router-dom";
// import RadialGradient from 'react-native-radial-gradient';

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class CostTemplate extends React.Component {
  state = {
    mainData: null,
    // ZenVerBarChart: null,
    // ZenHorBarChart: null,
    ZenWaterfallChart: null,
    ZenClusterColumnVer:null,
    gtRespClusterColumnVer: null,
    GtTrend: null,
    GtRm: null,
    GtManpower: null,
    GtLpg: null,
    GtMseb: null,
    GtCostGauge: null,
    GtHorCostContributor: null,
    GaugeVBarB: null,
    GaugeVBarG: null,
    ZenGauge: null,
    Angela: null,
   
    Gt1A: null,
    Gt2A: null,
    Gt3A: null,
    Gt1B: null,
    Gt2B: null,
    Gt3B: null,
    Gt1C: null,
    Gt2C: null,
    Gt3C: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  onChange = (e) => {
    
    const st = this;
    this.setState({
      ...this.state,
      selectedTab: e.target.value,
      loading: true,
    });
    this.fetchTrendData(e.target.value);
  };

  changeLid = (lid) => {
    let val =
      this.state.lid === "all" ? lid : this.state.lid === lid ? "all" : lid;
    this.setState({ ...this.state, lid: val, dataLoading: true });
    this.fetchTrendData(this.state.selectedTab, val, this.state.selectedMnt);
  };

  getTabs() {
    liracrypt
      .get("/corp/corpdashdynamicparam", {})
      .then((response) => {
        let __tabs = response.data.data;
        this.setState(
          {
            tabsData: __tabs,
            selectedTab: __tabs?.find((x) => x.isDefault === true)?.subTyp,
          },
          () => {
            if (this._isMounted && this.state.selectedTab) {
              this.fetchTrendData(this.state.selectedTab);
            }
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }

  componentDidMount() {
    this.props.setPageHeader("Dashboard");
    this._isMounted = true;
    this.getTabs();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = (selectedTab, lid = "all", mnt = "all") => {
    liracrypt
      .get("/textapi", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        dn: "TemplateCostChartGT",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};

        // respData["ZenVerBarChart"] = resp["data"]["ZenVerBarChart"];
        // respData["ZenHorBarChart"] = resp["data"]["ZenHorBarChart"];
        respData["ZenWaterfallChart"] = resp["data"]["ZenWaterfallChart"];
        respData["ZenClusterColumnVer"] = resp["data"]["ZenClusterColumnVer"];
        respData["gtRespClusterColumnVer"] = resp["data"]["gtRespClusterColumnVer"];

        // respData["ZenGauge"] = resp["data"]["ZenGauge"];
        respData["GtTrend"] = resp["data"]["GtTrend"];
        respData["GtTrend"] = resp["data"]["GtTrend"];
        respData["GtCostGauge"] = resp["data"]["GtCostGauge"];
        respData["GtHorCostContributor"] = resp["data"]["GtHorCostContributor"];
        respData["GaugeVBarB"] = resp["data"]["GaugeVBarB"];
        respData["GaugeVBarG"] = resp["data"]["GaugeVBarG"];
        // respData["Angela"] = resp["data"]["Angela"];

        
        respData["Gt1A"] = resp["data"]["Gt1A"];
        respData["Gt1B"] = resp["data"]["Gt1B"];
       
        respData["Gt2A"] = resp["data"]["Gt2A"];
        respData["Gt2B"] = resp["data"]["Gt2B"];
        respData["Gt3A"] = resp["data"]["Gt3A"];
        respData["Gt3B"] = resp["data"]["Gt3B"];

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // 
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  changeBasicGraph(data) {
    let val =
      this.state.selectedMnt === "all"
        ? data._id
        : this.state.selectedMnt === data._id
        ? "all"
        : data._id;
    this.setState({
      selectedMnt: val,
      dataLoading: true,
    });
    this.fetchTrendData(this.state.selectedTab, this.state.lid, val);
  }

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            <div
              style={{
                display: "inline-flex",
                alignContent: "center",
                alignItems: "center",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <div
                className="logo"
                style={{
                  margingLeft: 14,
                  padding: 10,
                }}
              >
                <img src={digitalFactoryLogo} alt="sarex" width="80" />
              </div>
              <Radio.Group
                className="managerTabs"
                value={"small"}
                onChange={this.onChange}
              >
                {this.state.tabsData &&
                  this.state.tabsData.map((tab, index) => (
                    <Radio.Button
                      key={index}
                      className={tab?.label?.toLowerCase()}
                      style={{
                        background: "#191C24",
                        border: "1px solid #3c3e4f",
                        color: tab?.color,
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        boxShadow: boxShadow,
                        maxWidth: "200px",
                      }}
                      value={tab?.subTyp}
                    >
                      {tab?.label}
                    </Radio.Button>
                  ))}
              </Radio.Group>
              <div
                style={{
                  //   boxShadow:
                  //     "rgb(30 30 30) 5px 5px 10px, rgb(46 46 46) -5px -5px 10px",
                  borderRadius: 10,
                  padding: 10,
                  marginRight: 25,
                  marginBottom: 13,

                  background: "#191C24",
                  //   backgroundImage:
                  //     "linear-gradient(145deg, rgba(106,106,111,1) 0%, rgba(42,42,52,0.8748541652989321) 57%, rgba(33,32,40,1) 100%)",
                  border: "1px solid #3c3e4f",
                }}
              >
                <Link to="/dashboard">
                  <HomeOutlined
                    style={{
                      fontSize: 25,
                    }}
                  />
                </Link>
              </div>
            </div>
            {this.state.loading === false ? (
              <div>
                <Row>
                  <Col span={24}>
                    {this.state.mainData ? (
                      <div
                        style={{
                          margin: "10px",
                          padding: "10px",
                        }}
                      >
                        <div style={{
                          color : "#bdc3c7",
                          fontSize: 36,
                          fontWeight: 800,
                          textAlign: "center",
                          margin : "0px 0px 0px 0px"
                           }}>
                        COST DASHBOARD
                        </div>
                       


                      
                       
                      </div>
                    ) : null}
                  </Col>
                  <Col span={8} style={{}}></Col>

                  <Col span={12}></Col>
                </Row>
                <Row className="outer_table">
                  <Col span={12}></Col>
                {/* </Row>

                <Row> */}
                  {/* <div className="App">
                    <h1>Props !</h1>
                    <Angela
                      data={this.state.Angela.data}
                      config={this.state.Angela.config}
                      name="Annnnil"
                      email="anil@test.com"
                    ></Angela>
                  </div> */}

                  {/* <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                marginTop: "10px",
                width: "800px",
              }}
            > */}
                  {/* <Angela name={this.state.name} email="anil@test.com"></Angela> */}
                  {/* <Angela name={"AAAANIL"} email="anil@test.com"></Angela>
                   */}
                  {/* <Angela
                divId={"Angela_01"}
                data={this.state.Angela.data}
                config={this.state.Angela.config}
              /> */}
                  {/* </div> */}
                </Row>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
          {/* <Row
            style={{
              background: "#000000",
            }}
          >
            <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                margin: "10px 0px 0px 20px",
              }}
            >
              <ZenVerBarChart
                divId={"GtTrend1"}
                // respData = {this.state.ZenVerBarChart}
                data={this.state.GtTrend.data}
                config={this.state.GtTrend.config}
                onChange={(data) => this.changeBasicGraph(data)}
              />
            </div>
            <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                margin: "10px 0px 0px 10px",
                width: "150px",
                height: "200px",
              }}
            >
              <ZenGauge
                divId={"GaugeVBarG"}
                data={this.state.GaugeVBarG.data}
                config={this.state.GaugeVBarG.config}
              />

              <ZenVerBarChart
                divId={"GaugeVBarB"}
                data={this.state.GaugeVBarB.data}
                config={this.state.GaugeVBarB.config}
                onChange={(data) => this.changeBasicGraph(data)}
              />
            </div>
          </Row> */}
          <Row
            style={{
              background: "#000000",
            }}
          >
            <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                margin: "10px 20px 20px 20px",
                width: "96%",
              }}
            >

              <Row>
                <Col span={16}>
                  <div>
                    <ZenVerBarChart
                      divId={"GtTrend2"}
                      data={this.state.GtTrend.data}
                      config={this.state.GtTrend.config}
                      onChange={(data) => this.changeBasicGraph(data)}
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <div
                    style={{
                      borderRadius: "10px",
                      background: "#191C24",
                      border: "1px solid #3c3e4f",
                      margin: "10px 0px 0px 40px",
                      width: "80%",
                    }}
                  >
                    <ZenGauge
                      divId={"GtCostGauge1"}
                      data={this.state.GtCostGauge.data}
                      config={this.state.GtCostGauge.config}
                    />

                    <div
                      style={{
                        margin: "0px 0px 0px 75px",
                        width: "80%",
                        color: "#bdc3c7",
                        fontSize: 16,
                      }}
                    >
                      Current Month Status
                    </div>
                    <div
                      style={{
                        margin: "0px 0px 0px 105px",
                        width: "80%",
                        color: "#bdc3c7",
                        fontSize: 12,
                      }}
                    >
                      Tgt 350 Act 276
                    </div>
                  </div>

                  <div
                    style={{
                      borderRadius: "10px",
                      background: "#191C24",
                      border: "1px solid #3c3e4f",
                      margin: "10px 0px 10px 40px",
                      width: "80%",
                    }}
                  >
                    <ZenHorBarChart
                      divId={"GtHorCostContributor1"}
                      data={this.state.GtHorCostContributor.data}
                      config={this.state.GtHorCostContributor.config}
                      onChange={(data) => this.changeBasicGraph(data)}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </Row>
{/* GT Row 1 */}
          <Row style={{   background: "#000000"}} >
            <Col span={11}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <ZenVerBarChart
                  divId={"Gt1A"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.Gt1A.data}
                  config={this.state.Gt1A.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col span={11}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 20px 15px 10px",
                }}
              >
                <ZenVerBarChart
                  divId={"Gt1B"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.Gt1B.data}
                  config={this.state.Gt1B.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            
          </Row>

{/* GT Row2 */}
          <Row style={{   background: "#000000"}} >
            <Col span={11}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <ZenVerBarChart
                  divId={"Gt2A"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.Gt2A.data}
                  config={this.state.Gt2A.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col span={11}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 20px 15px 10px",
                }}
              >
                <ZenVerBarChart
                  divId={"Gt2B"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.Gt2B.data}
                  config={this.state.Gt2B.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
           
          </Row>
{/* GT Row3 */}

          <Row style={{   background: "#000000"}} >
            <Col span={11}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 0px 15px 10px",
                }}
              >
                <ZenVerBarChart
                  divId={"Gt3A"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.Gt3A.data}
                  config={this.state.Gt3A.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col span={11}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "15px 20px 15px 10px",
                }}
              >
                <ZenVerBarChart
                  divId={"Gt3B"}
                  // respData = {this.state.ZenVerBarChart}
                  data={this.state.Gt3B.data}
                  config={this.state.Gt3B.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
          </Row>
{/* Waterfall */}
          <Row style={{   background: "#000000"}} >
          <div
                          style={{
                            borderRadius: "10px",
                            background: "#191C24",
                            border: "1px solid #3c3e4f",
                            margin: "10px 0px 0px 10px",
                         
                            width: "600px"
                          }}
                        >
                          <ZenWaterfallChart
                            divId={"ZenWaterfallChart1"}
                            data={this.state.ZenWaterfallChart.data}
                            config={this.state.ZenWaterfallChart.config}
                            onChange={(data) => this.changeBasicGraph(data)}
                          />
                        </div>






                        <div
              style={{
                borderRadius: "10px",
                background: "#191C24",
                border: "1px solid #3c3e4f",
                margin: "10px 0px 0px 20px",
                width: "600px"
              }}
            >
              <ZenClusterColumnVer
                divId={"chartdiv"}
                // respData = {this.state.ZenVerBarChart}
                data={this.state.gtRespClusterColumnVer.data}
                config={this.state.gtRespClusterColumnVer.config}
                onChange={(data) => this.changeBasicGraph(data)}
              />
            </div>






          </Row>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default CostTemplate;
